import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  button: {
    height: '48px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '358px',
    },
  },
  customContentContainer: {
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
    },
  },
  customMessage: {
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
}));
